
module.exports = {
    paddingProportion: 1/12
};

